import type { CompanyLicensing, LicensingCatalog } from '../api/plan-licensing.service';

/** Match server add-on authorization; a missing/erroring lookup is never legacy. */
export function canAddPlanProduct(product: { featureKey?: string | null; isModule?: boolean }, licensing: CompanyLicensing | undefined, catalog: LicensingCatalog | undefined): boolean {
  if (!licensing) return false;
  if (licensing.mode === 'LEGACY') return true;
  if (!licensing.current || licensing.current.plan.deletedAt || !product.featureKey || ['users', 'whatsapp_connections'].includes(product.featureKey)) return false;
  if (product.featureKey === 'allow_api' && product.isModule) return true;
  if (!catalog) return false;
  const dependency = product.featureKey === 'alicia_tokens' ? 'allow_ai'
    : product.featureKey === 'mass_messages_per_month' ? 'campaigns' : product.featureKey;
  return !(product.isModule || catalog.capabilities.some((capability) => capability.key === dependency))
    || licensing.capabilityKeys.includes(dependency);
}
